<template>
  <div>
    <v-container id="search-container">
      <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
      <v-form v-model="valid" lazy-validation>
        <v-row dense>
          <v-col cols="12">
            <p class="mb-0 font-weight-bold">
              Enter search criteria. No criteria returns ALL records (may take a
              little while)
            </p>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6" class="sel-int-col-100">
            <label>From&nbsp;Date</label>
            <select v-model="sterm.frm_date">
              <option v-for="dy in days" :key="dy" :value="dy">
                {{ dy }}
              </option>
            </select>
          </v-col>
          <v-col cols="6" class="sel-int-col-100">
            <label class="mr-2">To&nbsp;Date&nbsp;</label>
            <select v-model="sterm.to_date">
              <option v-for="dy in days" :key="dy" :value="dy">
                {{ dy }}
              </option>
            </select>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6" class="sel-int-col-100">
            <label>Start&nbsp;Time</label>
            <select v-model="sterm.start_time">
              <option v-for="hr in hours" :key="hr" :value="hr">
                {{ hr }}
              </option>
            </select>
          </v-col>
          <v-col cols="6" class="sel-int-col-100">
            <label>End&nbsp;Time</label>
            <select v-model="sterm.end_time">
              <option v-for="hr in hours" :key="hr" :value="hr">
                {{ hr }}
              </option>
            </select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              maxlength="120"
              v-model="sterm.officer_name"
              label="Officer Name"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between">
            <v-btn
              color="cmpbk"
              class="mr-4 white--text"
              @click.prevent="search"
            >
              Search
            </v-btn>
            <v-btn color="cmpbk" class="mr-4 white--text" @click="reset">
              Clear Form
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
@media (min-width: 0px) {
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-100 select {
    width: 100%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
  // .sel-int-col-25 label {
  //   position: relative;
  //   top: 25px;
  // }
  .sel-int-col-25 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
}
@media (min-width: 768px) {
  .sel-int-col-100 {
    width: 100%;
    // height: 55px;
    // position: relative;
    // top: -25px;
  }

  .sel-int-col-100 select {
    width: 40%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    margin-left: 10px;
    // position: relative;
    // top: 10px;
  }
  // .sel-int-col-25 label {
  //   position: relative;
  //   top: 25px;
  // }
  .sel-int-col-25 select {
    width: 80%;
    color: blue;
    outline: 1px solid black;
    height: 45px;
    font-size: 18px;
    padding-left: 5px;
    // position: relative;
    // top: 10px;
  }
}
select {
  -webkit-appearance: listbox !important;
  appearance: listbox !important;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "adm_search",
  mixins: [bus_common],
  data() {
    return {
      valid: false,
      sterm: {
        frm_date: "None",
        to_date: "None",
        officer_name: "",
        start_time: "None",
        end_time: "None",
      },
    };
  },
  computed: {
    hours() {
      var hrs = [];
      hrs.push("None");
      for (let i = 1; i < 24; i++) {
        hrs.push((i * 100).toString().padStart(4, "0"));
      }
      return hrs;
    },
    days() {
      var dys = [];
      dys.push("None");
      for (let i = 0; i < 30; i++) {
        var today = new Date();
        today.setDate(today.getDate() - i);
        var x = this.format_date_us(today);
        dys.push(x);
      }
      return dys;
    },
  },
  methods: {
    search() {
      this.$emit("search");
    },
    reset() {},
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      var today = new Date();
      today = this.format_date_us(today);
      this.sterm.frm_date = today;
      this.sterm.to_date = today;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
